<template>
    <div class="driver-unloading">
        <UnloadingToggle v-model="state"
                         @toggle="onToggle"
                         :disabled="disabled"
                         :labels="{checked: 'Unloaded', unchecked: 'Unload'}"/>

        <ConfirmUnloaded v-model="showUnloadingConfirm"
                         :carItineraryHelper="carItineraryHelper"
                         :accessType="accessType"
                         :encryptedData="encryptedData"
                         @confirm="confirmationConfirmed"
                         @cancel="updateState(false)"
                         @changeForbidden="disabled=true"
                         @error="updateState(false)"></ConfirmUnloaded>

        <ConfirmUnloadingCancelled v-model="showUnloadingCancelledConfirm"
                         :carItineraryHelper="carItineraryHelper"
                         :accessType="accessType"
                         :encryptedData="encryptedData"
                         @confirm="updateState(false)"
                         @cancel="updateState(true, null)"
                         @changeForbidden="changeForbidden"
                         @error="updateState(true, null)"></ConfirmUnloadingCancelled>
        <div v-if="signatureVisible" class="consignee-signature-link">
            <router-link v-if="isPrivate()" :to="{ name: 'SignDelivery', params: { carItineraryId: carItineraryHelper.getCarItinerary().id }}">Take Consignee Signature</router-link>
            <router-link v-else-if="isPublic()" :to="{ name: 'EncryptedSignDelivery', params: { carItineraryId: carItineraryHelper.getCarItinerary().id, encryptedData: encryptedData }}">Take Consignee Signature</router-link>
        </div>
    </div>
</template>

<script>

import AccessType from '@/components/Core/AccessType'
import moment from 'moment'
import UnloadingToggle from '@/components/Core/Input/Toggle'
import ConfirmUnloaded from '@/components/CarItinerary/Delivery/DriverUnloadingToggle/ConfirmUnloaded'
import ConfirmUnloadingCancelled from '@/components/CarItinerary/Delivery/DriverUnloadingToggle/ConfirmUnloadingCancelled'

export default {
  extends: AccessType,
  components: {
    UnloadingToggle, ConfirmUnloaded, ConfirmUnloadingCancelled
  },
  created () {
    this.updateDisabled()
  },
  props: {
    carItineraryHelper: {
      type: Object,
      required: true
    }
  },
  name: 'DriverUnloading',
  data () {
    return {
      showUnloadingConfirm: false,
      showUnloadingCancelledConfirm: false,
      state: this.carItineraryHelper.isUnloaded(),
      disabled: false,
      signatureVisible: !this.carItineraryHelper.hasConsigneeSignature() && this.carItineraryHelper.isUnloaded()
    }
  },
  methods: {
    confirmationConfirmed (response) {
      if (response.data.data.unloadedDate !== undefined) {
        this.updateState(true, response.data.data.unloadedDate)

        this.disabled = !this.allowCancellingUnloaded()
      } else {
        this.updateState(false)
      }
    },
    updateState (state, unloadingDate) {
      this.state = state

      if (state) {
        if (!this.carItineraryHelper.hasConsigneeSignature()) {
          this.showSignature()
        }
        this.$emit('unloadingConfirmed', unloadingDate)
      } else {
        this.hideSignature()
        this.$emit('unloadingCancelled')
      }
    },
    onToggle (e) {
      if (e.value) {
        this.showUnloadingConfirm = true
      } else {
        this.showUnloadingCancelledConfirm = true
      }
    },
    changeForbidden () {
      this.updateState(true)
      this.disabled = true
    },
    allowCancellingUnloaded () {
      return (!this.carItineraryHelper.isUnloaded() && this.carItineraryHelper.isPickedUp()) || (this.carItineraryHelper.isUnloaded() && moment(this.carItineraryHelper.getCarItinerary().unloadedDate) > moment().subtract(1, 'days') && !this.carItineraryHelper.hasConsigneeSignature())
    },
    updateDisabled () {
      this.disabled = !this.allowCancellingUnloaded()
    },
    showSignature () {
      this.signatureVisible = true
    },
    hideSignature () {
      this.signatureVisible = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
    .driver-unloading {
        .consignee-signature-link {
            margin-bottom: 10px;
        }
    }
</style>
